import React from 'react';
import Login from '../components/Login';

const AuthPage = () => {
    return (
        <div>
            <Login />
        </div>
    );
};

export default AuthPage;
